import { ErrorBoundary, Text } from '@dixa/lib-shared-habla';

import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getEvaluationSummary } from './csatFilterEvaluationResults/utils';
import { FilterEvaluation } from './filterEvaluation';
import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type RatingOfferedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_RATING_OFFERED'>;
};

export const RatingOffered = ({ entry }: RatingOfferedProps): JSX.Element => {
  const hasFilterEvaluation =
    entry.evaluation_filters &&
    entry.evaluation_filters.filterEvaluations.length > 0;

  const { secondaryText: summarySub } = hasFilterEvaluation
    ? getEvaluationSummary(entry.evaluation_filters!)
    : { secondaryText: 'No filter evaluation results available' };

  const agentName = getLogEntryAuthorName({
    ...entry,
    author: entry.agent,
  });
  const agentLink = <UserLink userId={entry.agent.id}>{agentName}</UserLink>;

  const userName = getLogEntryAuthorName({ ...entry, author: entry.user });
  const userLink = <UserLink userId={entry.user.id}>{userName}</UserLink>;

  const text = (
    <>
      Conversation rating is offered to customer {userLink} for agent{' '}
      {agentLink}
    </>
  );

  return (
    <LogEntry
      text={text}
      icon="smile"
      entry={entry}
      secondaryText={summarySub}
      isExpandable={hasFilterEvaluation}
    >
      {hasFilterEvaluation && entry.evaluation_filters && (
        <ErrorBoundary
          fallback={<Text.Paragraph>Something went wrong</Text.Paragraph>}
        >
          <FilterEvaluation
            filterEvaluationResults={entry.evaluation_filters}
          />
        </ErrorBoundary>
      )}
    </LogEntry>
  );
};
